module.exports = __webpack_public_path__ + "static/media/Schritt_2_Gespraech_mit_der_Ehefrau.d9bea23c.pdf";